import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  fullScreen: {
    marginTop: '10%',
  },
  '@global': {
    '.MuiDialog-paperFullScreen': {
      borderRadius: '10px 10px 0px 0px',
    },
    '.MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  },
});

type typeMaxWidth = 'lg' | 'md' | 'sm' | 'xl' | 'xs';

type Props = {
  testid?: string;
  children: React.ReactNode;
  isFullWidth?: boolean;
  isFullScreen?: boolean;
  isOpen: boolean;
  typeMaxWidth?: typeMaxWidth;
  handleClose?: () => void;
  onBackdropClick?: () => void;
};

const DefaultModal = ({
  testid,
  children,
  isFullWidth = false,
  isFullScreen = false,
  isOpen,
  typeMaxWidth,
  onBackdropClick,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Dialog
      key={testid}
      data-testid={testid}
      className={isFullScreen ? classes.fullScreen : ''}
      fullScreen={isFullScreen}
      fullWidth={isFullWidth}
      maxWidth={typeMaxWidth}
      open={isOpen}
      onClick={onBackdropClick}
    >
      <DialogContent
        data-testid="dialog-content"
        onClick={(e: React.MouseEvent): void => e.stopPropagation()}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DefaultModal;
